import { css } from "@emotion/react"
import {
  Designation,
  DraftFrequency,
  Frequency,
  ValidationErrors,
} from "../types"
import { FrequencySelector } from "./FrequencySelector"
import { FundSelection } from "./FundSelection"

type LeftPaneProps = {
  designations: Designation[]
  frequency: Frequency
  draftFrequency?: DraftFrequency
  errors: ValidationErrors
}
export function LeftPane({
  designations,
  frequency,
  draftFrequency,
  errors,
}: LeftPaneProps) {
  return (
    <div
      className="d-f fd-c g-5 g-4@md f-2"
      css={css`
        min-width: 0; // allow flex items to shrink
        flex-basis: 60%;
      `}
    >
      <FundSelection {...{ designations, frequency, errors }} />
      <FrequencySelector {...{ frequency, draftFrequency }} />
    </div>
  )
}
